"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/NavBar.css");
var _logo_black = _interopRequireDefault(require("../assets/logo_black.png"));
var _Menu_icon = _interopRequireDefault(require("../assets/Menu_icon.png"));
var _reactRouterDom = require("react-router-dom");
var _dayjs = _interopRequireDefault(require("dayjs"));
require("dayjs/locale/fr");
var _NavMenu = _interopRequireDefault(require("./NavMenu"));
var _Alert = _interopRequireDefault(require("@mui/material/Alert"));
var _react = require("react");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : NavBar.js
* Description : Ce fichier contient la définition du composant NavBar 
*               Ce composant est un bandeau qui contient une barre de navigation avec des liens 
*               pour naviguer sur l'application
* Date de création : 23 septembre 2024
*/ /* CSS et assets */ /* Bibliothèques et composants */ // <-- importe la locale
/* Hook */ // définit 'fr' comme locale globale
_dayjs["default"].locale('fr');
var duration = require("dayjs/plugin/duration");
_dayjs["default"].extend(duration);
var customParseFormat = require("dayjs/plugin/customParseFormat");
_dayjs["default"].extend(customParseFormat);

/**
* NavBar : Ce composant affiche une une barre de bavigation avec des liens pour naviguer sur l'application
*
* Type : composant 
*
* Parametres : 
*  None
*/
function NavBar(_ref) {
  var name_app = _ref.name_app;
  // Define useState hooks
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    closed = _useState2[0],
    setClosed = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    passwordToChange = _useState4[0],
    setPasswordToChange = _useState4[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser,
    currentUserId = _useAuth.currentUserId,
    authConfirm = _useAuth.authConfirm;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path;
  var navigate = (0, _reactRouterDom.useNavigate)();

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  var handleLink = function handleLink(event, path) {
    event.preventDefault();
    navigate(path);
  };
  var handleClose = function handleClose(event) {
    event.preventDefault();
    sendRequestToChangeDatePassword();
    setClosed(true);
  };
  function sendRequestToChangeDatePassword() {
    return _sendRequestToChangeDatePassword.apply(this, arguments);
  } // Define useEffect hooks
  function _sendRequestToChangeDatePassword() {
    _sendRequestToChangeDatePassword = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, form_data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Création du Form Data
            form_data = new FormData();
            form_data.append("new_date_last_password", (0, _dayjs["default"])().format('YYYY-MM-DD'));
            // Update User
            _context.n = 1;
            return fetch(path + "/api/au-erus/" + currentUserId + "/change-date-password/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _sendRequestToChangeDatePassword.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (currentUser !== null) {
      if ((0, _dayjs["default"])().isAfter((0, _dayjs["default"])(currentUser["date_last_password"]).add(_dayjs["default"].duration({
        'months': 3
      })), 'day')) {
        setPasswordToChange(true);
      }
    } else {
      setPasswordToChange(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  // Render component
  return screenWidth > 680 ? authStatus && authConfirm ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "navbar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "navbar-start",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: '/equipments',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _logo_black["default"],
          alt: "Asclepios Tech logo",
          className: "navbar-logo"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("h1", {
        className: "navbar-title",
        children: [name_app, " - ASCLEPIOS TECH"]
      })]
    }), closed === false && authStatus && currentUser && passwordToChange === true && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_RESEARCH" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert["default"], {
      className: "alert",
      severity: "warning",
      onClose: handleClose,
      children: "Pensez \xE0 modifier votre mot de passe r\xE9guli\xE8rement !"
    }) : null, currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_RESEARCH" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "navbar-end",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        onClick: function onClick(e) {
          return handleLink(e, "/profile");
        },
        className: "navbar-status clickable",
        children: currentUser["username"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavMenu["default"], {
        name_app: name_app,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _Menu_icon["default"],
          alt: "menu_icon",
          className: "navbar-icon"
        })
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "navbar-end",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        onClick: function onClick(e) {
          return handleLink(e, "/profile");
        },
        className: "navbar-status clickable",
        children: currentUser["username"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavMenu["default"], {
        name_app: name_app,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _Menu_icon["default"],
          alt: "menu_icon",
          className: "navbar-icon"
        })
      })]
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "navbar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "navbar-start",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _logo_black["default"],
        alt: "Asclepios Tech logo",
        className: "navbar-logo"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("h1", {
        className: "navbar-title",
        children: [name_app, " - ASCLEPIOS TECH"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "navbar-status",
      children: "D\xE9connect\xE9"
    })]
  }) : authStatus && authConfirm ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "navbar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "navbar-start",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: '/equipments',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _logo_black["default"],
          alt: "Asclepios Tech logo",
          className: "navbar-logo-ss"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        className: "navbar-title",
        children: name_app
      })]
    }), closed === false && authStatus && currentUser && passwordToChange === true && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_RESEARCH" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert["default"], {
      className: "alert",
      severity: "warning",
      onClose: handleClose,
      children: "Pensez \xE0 modifier votre mot de passe r\xE9guli\xE8rement !"
    }) : null, currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_RESEARCH" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "navbar-end",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        onClick: function onClick(e) {
          return handleLink(e, "/profile");
        },
        className: "navbar-status-ss clickable",
        children: currentUser["username"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavMenu["default"], {
        name_app: name_app,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _Menu_icon["default"],
          alt: "menu_icon",
          className: "navbar-icon-ss"
        })
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "navbar-end",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        onClick: function onClick(e) {
          return handleLink(e, "/profile");
        },
        className: "navbar-status-ss clickable",
        children: currentUser["username"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavMenu["default"], {
        name_app: name_app,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _Menu_icon["default"],
          alt: "menu_icon",
          className: "navbar-icon-ss"
        })
      })]
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "navbar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "navbar-start",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _logo_black["default"],
        alt: "Asclepios Tech logo",
        className: "navbar-logo-ss"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        className: "navbar-title",
        children: name_app
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "navbar-status-ss",
      children: "D\xE9connect\xE9"
    })]
  });
}
var _default = exports["default"] = NavBar;